import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import LotteryRecords from '../entities/lottery-records'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';

interface LotteryRecordsState extends ListState<LotteryRecords> {
    editLotteryRecords: LotteryRecords;
    permissions: Array<string>
}

class LotteryRecordsModule extends ListModule<LotteryRecordsState, any, LotteryRecords> {
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<LotteryRecords>(),
        loading: false,
        editLotteryRecords: new LotteryRecords(),
        permissions: new Array<string>()
    }
    actions = {
        async getAll(context: ActionContext<LotteryRecordsState, any>, payload: any) {
            context.state.loading = true;
            let response = await Ajax.get('/api/services/app/LotteryRecords/GetAll', { params: payload.data });
            context.state.loading = false;
            let page = response.data.result as PageResult<LotteryRecords>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async create(context: ActionContext<LotteryRecordsState, any>, payload: any) {
            await Ajax.post('/api/services/app/LotteryRecords/Create', payload.data);
        },

        async get(context: ActionContext<LotteryRecordsState, any>, payload: any) {
            let response = await Ajax.get('/api/services/app/LotteryRecords/Get?Id=' + payload.id);
            return response.data.result as LotteryRecords;
        },

    };
    mutations = {
        setCurrentPage(state: LotteryRecordsState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: LotteryRecordsState, pagesize: number) {
            state.pageSize = pagesize;
        },
        edit(state: LotteryRecordsState, lotteryRecords: LotteryRecords) {
            state.editLotteryRecords = lotteryRecords;
        }
    }
}

const lotteryRecordsModule = new LotteryRecordsModule();
export default lotteryRecordsModule;